import * as angular from 'angular';
import * as moment from 'moment';

import { ISessionStorageService } from '../general/sessionStorage.service';
import { IConnectionPointService } from './connectionPoint.service';
import { IApplicationConfiguration, Application } from '../../models';

export interface ICurrentApplicationService {
    resetApplication();
    setApplication(application: Application): angular.IPromise<void>;
    getApplicationConfiguration(): IApplicationConfiguration;
    refreshCurrentApplication(): angular.IPromise<void>;
}

export class CurrentApplicationService implements ICurrentApplicationService {
    static serviceId = 'currentApplicationService';
    static $inject = ['sessionStorageService', 'connectionPointService'];

    private _key = 'applicationConfiguration';

    constructor(
        private _sessionStorageService: ISessionStorageService,
        private _connectionPointService: IConnectionPointService,
    ) { }

    resetApplication(): void {
        this._sessionStorageService.setTo(this._key, JSON.stringify({}));
    }

    setApplication(application: Application): angular.IPromise<void> {
        const applicationConfiguration: IApplicationConfiguration = Object.assign({}, application,
            {
                beginDayTime: moment.duration(application.dayBeginTime),
                interval: null,
                intervalTimeUnit: null,
                timeZone: application.olsonTimeZoneName,
                defaultDatabaseGuid: application.defaultConnectionPointGuid
            });
        return this.refreshApplication(applicationConfiguration, application.defaultConnectionPointGuid);
    }

    refreshCurrentApplication(): angular.IPromise<void> {
        const config = this.getApplicationConfiguration();
        return this.refreshApplication(config, config.defaultDatabaseGuid);
    }

    private refreshApplication(applicationConfiguration, defaultConnectionPointGuid: string): angular.IPromise<void> {
        return this._connectionPointService
            .getByGuid(defaultConnectionPointGuid, true)
            .then(cpDto => {
                const connectionPoint = cpDto.connectionPoint;
                applicationConfiguration.interval = connectionPoint.interval;
                applicationConfiguration.intervalTimeUnit = connectionPoint.intervalTimeUnit;
                applicationConfiguration.defaultDatabaseUpToDate = cpDto.hasAccess ? cpDto.upToDate : true;
                applicationConfiguration.hasAccessToDefaultDatabase = cpDto.hasAccess;
                this._sessionStorageService.setTo(this._key, JSON.stringify(applicationConfiguration));
            });
    }

    getApplicationConfiguration(): IApplicationConfiguration {
        const applicationConfiguration = JSON.parse(this._sessionStorageService.getFrom(this._key));
        if (applicationConfiguration) {
            applicationConfiguration.beginDayTime = moment.duration(applicationConfiguration.beginDayTime);
        }
        return applicationConfiguration;
    }
}